import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { makeStyles, Typography } from './../../../../assets/theme/default';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.typography.body2.fontSize,
    lineHeight: 1,
    whiteSpace: 'nowrap'
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));

const LinkEntity = ({ entity }) => {

  const classes  = useStyles();

  return (
    <Typography
      className={ classNames(
        classes.root,
        classes.link
      )}
      component={ NavLink }
      to={ `/entity/detail/${ entity._id }` }
    >
      { entity.name }
    </Typography>
  )

};

LinkEntity.propTypes = {
  entity: PropTypes.object
};

export default LinkEntity;
